import axios from "axios";
import { supabase } from "../../../../supabaseClient";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./CheckVirtualAccountStatus.module.css";
import Close from "../../../Icons/Close";
//subComponent
import Button from "../../../../Subcomponents/Button";
import { useSelector } from "react-redux";
import Dot from "../../../Icons/Dot";
import LeadStatusChip from "../../../../Subcomponents/LeadStatusChip";
import { dismissLoader, presentLoader } from "../../../../Services/loader";
import { getVirtualAccDetailsById } from "../../../../Services/AllAllotments";
import { getLeadVirtualAccountStatus } from "../../../../Services/Lead";
import { errorTost } from "../../../../Services/Toast";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));

export default function UpdateLeadDetails({
  open,
  handleClose,
  leadDisplayId,
  crm2LeadId = null, // CRM2 M6-F2 (M6.34): from the CRM 2.0 card — the units that still use the VA
}) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const classes = useStyles();
  const [virtualAccountStatus, setVirtualAccountStatus] = useState("");
  const [crm2Va, setCrm2Va] = useState(null);
  useEffect(() => {
    if (!crm2LeadId) return;
    axios
      .get(`${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/va/status/${crm2LeadId}`, { headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` } })
      .then((r) => setCrm2Va(r?.data?.data || null))
      .catch((err) => console.error("[crm2][CheckVirtualAccountStatus] VA status failed", { leadId: crm2LeadId, message: err?.response?.data?.message || err?.message }));
  }, [crm2LeadId]);

  useEffect(() => {

    const getVirtualAccountData = () => {
      presentLoader();
      getVirtualAccDetailsById(leadDisplayId)
        .then((resp) => {
          let body = {
            virtualAccId: resp?.data[0]?.virtualAccId,
          };
          getLeadVirtualAccountStatus(body)
            .then((resp) => {
              dismissLoader();
              setVirtualAccountStatus(resp?.data?.status || "not created");
            })
            .catch((error) => {
              dismissLoader();
              console.error(error);
              errorTost(error);
            });
        })
        .catch((err) => {
          dismissLoader();
          errorTost(err.message);
        });
    };

    getVirtualAccountData();
  }, [leadDisplayId]);

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span
            className={classes.closeIcon}
            onClick={handleClose}
            tabIndex={0}
          >
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Virtual Account Status</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.content}>
            <div
              className={cssClasses.title}
              style={{
                marginTop: "2rem",
                lineHeight: "3rem",
                color: "#667085",
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              Your virtual account is{" "}
              {virtualAccountStatus === "closed" ? (
                <LeadStatusChip
                  label={"closed"}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                ></LeadStatusChip>
              )  : virtualAccountStatus === 'active' ? (
                <LeadStatusChip
                  label={virtualAccountStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                ></LeadStatusChip>
              ) : virtualAccountStatus === "not created" ? (
                <LeadStatusChip
                  label={"not created"}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#FF4405", backgroundColor: "#FFE6D5", }}
                ></LeadStatusChip>
              ) : virtualAccountStatus ? (
                <LeadStatusChip
                  label={virtualAccountStatus}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                ></LeadStatusChip>
              ) : (
                ""
              )}{" "}
            </div>
            {crm2Va && (
              <div style={{ textAlign: "center", color: "#475467", fontSize: "1.4rem", lineHeight: "2.2rem", marginTop: "1rem" }}>
                {/* the status above comes live from Razorpay; the saved Leads status can be out of date, so it is not shown again */}
                {String(virtualAccountStatus).toLowerCase() === "active" && crm2Va.usedBy?.length > 0 && <div>Used now for: {crm2Va.usedBy.join(", ")}</div>}
                <div style={{ color: "#667085", fontSize: "1.3rem" }}>One account per customer. It closes only when no booking of this customer needs it.</div>
              </div>
            )}
          </div>
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Ok"}
              clicked={() => handleClose()}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
